export class SocialShareService {
    constructor($resource, ApiService) {
        'ngInject';

        this.$resource = $resource;
		this.apiService = ApiService;

		this.socialShareResourceUrl = this.apiService.getResourceUrl('social-share');

		this.socialShareResource = this.$resource(this.socialShareResourceUrl);        
    }

    getSocialShareAppIds() {
        const promise = this.socialShareResource.get().$promise;

        return promise
            .then(details => this._getSubContentDetails(details.data))
            .catch(err => {
                throw this.apiService.getErrorMessage(err);
            });
    }

    _getSubContentDetails({social_share_app_ids:socialShareAppIds}) {
        return socialShareAppIds.map(({name,app_id:appId}) => ({name, appId}));
    }
}


// WEBPACK FOOTER //
// ./src/app/common/components/social-share/social-share.service.js